import { combineReducers } from 'redux';

import errors from './errors';

import { ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__SUCCESS } from '../../actionTypes';


const data = (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__SUCCESS:
      return action.payload.availability;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  errors,
});
